import { render } from "./JobInfo.vue?vue&type=template&id=2806c04e"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__